'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';
import {reportItemModel} from "../../models/reportitemmodel.js";

export class ReportPreviewCtrl extends ListCtrl {
    storageNames = {query: ''};

    static fmtUTCddmmyyyy(epoch) {
        const num = Number(epoch);
        if (!Number.isFinite(num) || num <= 0) return '';
        const ts = num > 1e12 ? Math.floor(num / 1000) : num;
        const d = new Date(ts * 1000);
        const dd = String(d.getUTCDate()).padStart(2, '0');
        const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
        const yy = d.getUTCFullYear();
        return `${dd}/${mm}/${yy}`;
    }

    constructor($scope, $http, $filter, $timeout, $locale, jsDataService) {
        super($scope, $http, $filter, $timeout, $locale, jsDataService);
        this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
        const baseKey = this.jsDataService.get('cfgQueryStorageKey', '');
        const suffix = window.location.pathname.replace(/\W+/g, '_');
        this.storageNames.query = `${baseKey}_${suffix}`;
        const saved = localStorage.getItem(this.storageNames.query);
        if (saved) this.query = JSON.parse(saved);
        $scope.$watch(() => this.query.filters, () => {
            localStorage.setItem(this.storageNames.query, JSON.stringify(this.query));
        }, true);
        if (this.classif?.users) {
            for (const u of this.classif.users) u.title = `${u.name} ${u.lastname}`;
        }
        const style = document.createElement('style');
        style.innerHTML = `.hide-mf .ew-search-container md-input-container[flex="nogrow"]{display:none!important;}`;
        document.head.appendChild(style);
        const toggle = () => {
            const onlyQuery = Object.keys(this.query.filters).length === 1;
            document.body.classList.toggle('hide-mf', onlyQuery);
        };
        $timeout(toggle, 0);
        $scope.$watch(() => this.query.filters, toggle, true);
        $scope.$on('$destroy', () => {
            document.body.classList.remove('hide-mf');
            document.head.removeChild(style);
        });
    }

    setData(data) {
        this.data = data.map(ln => new reportItemModel(ln, this.$filter, this.jsDataService));
    }

    getColValue(row, col) {
        if (typeof row[col] === 'undefined') return '';

        return row instanceof reportItemModel ? row.getValue(col) : row[col];
    }

    exportList() {
        const q = new URLSearchParams({
            filters: JSON.stringify(this.query.filters),
            limit: this.query.limit,
            page: this.query.page,
        });
        const ts = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '');
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = `${this.cfgExportUrl}?${q.toString()}`;
        a.download = `Applications_report_${ts}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    loadData() {
        if (!this.initialized) return;

        const query = structuredClone(this.query);
        for (const n in query.filters) {
            const filter = query.filters[n];
            if (!filter || filter.value == null) continue;
            if (filter.type !== 'datepicker') continue;
            if (n === 'query') continue;
            const v = filter.value;
            const isDateObj = v instanceof Date && !isNaN(v.getTime());
            const isDateStr = typeof v === 'string' && !Number.isNaN(Date.parse(v));
            if (isDateObj || isDateStr) {
                const d = isDateObj ? new Date(v.getTime()) : new Date(v);
                const offset = d.getTimezoneOffset();
                d.setMinutes(d.getMinutes() - offset);
                filter.value = d;
            }
        }

        const url = this.jsDataService.get('cfgDataUrl');
        if (!url) return;

        this.promise = this.$scope.basicHttpConfigProcess({
            url,
            method: 'GET',
            params: query
        }).then((response) => {
            if (response.data.success) {
                this.setData(response.data.data);
                this.total = response.data.total;
                this.setTotals(response.data);
            }
        }, () => {});
    }
}

ReportPreviewCtrl.$inject = [
    '$scope', '$http', '$filter', '$timeout', '$locale', 'jsDataService'
];
